module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='ResultError\n'+
((__t=( error ))==null?'':__t)+
'\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/browser/ResultError.html
// module id = 70
// module chunks = 0